(function() {
    'use strict';

    angular.module('process')
        .controller('ProcessUpdateController', ProcessUpdateController);

    ProcessUpdateController.$inject = ['$state', '$uibModal', 'processDataSrvc', 'notificationSrvc', 'processMessagesConst', 'processStageDataSrvc', 'processStageSrvc', 'processStageMessagesConst', 'processstagePermissionsConst', 'errorNotificationSrvc'];

    function ProcessUpdateController($state, $uibModal, processDataSrvc, notificationSrvc, processMessagesConst, processStageDataSrvc, processStageSrvc, processStageMessagesConst, processstagePermissionsConst, errorNotificationSrvc) {
        var self = this;

        self.loading = true;

        self.serverErrors = {
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            nonFieldErrors: []
        };
        self.processData = {};

        self.updateProcess = updateProcess;
        self.cleanErrors = cleanErrors;

        self.processStagesCols = [{
            title: 'Maszyna',
            value: 'machine_name',
            type: 'text'
        }, {
            title: 'Czynność maszyny',
            value: 'machine_action_name',
            type: 'text'
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.processStagesRows = [];
        self.modelPermissions = processstagePermissionsConst;
        self.onProcessStageReorder = onProcessStageReorder;
        self.onProcessStageCreate = onProcessStageCreate;
        self.onProcessStageEdit = onProcessStageEdit;
        self.onProcessStageDelete = onProcessStageDelete;

        activate();

        function activate() {
            getProcess();
            getProcessStagesRows();
        }

        function getProcess() {
            return processDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.processData = response;

                delete self.processData.date_modified;
                delete self.processData.date_added;
                return response;
            });
        }

        function getProcessStagesRows() {
            self.loading = true;

            return processStageDataSrvc.forProcess({
                process_pk: $state.params.pk
            }).$promise.then(function(response) {
                self.processStagesRows = response;
                return response;
            }).finally(function(response) {
                self.loading = false;
                return response;
            });
        }

        function getProcessStagesRow(process_stage_pk, callback) {
            self.loading = true;

            return processStageDataSrvc.forProcess({
                process_stage_pk: process_stage_pk
            }).$promise.then(
                callback
            ).finally(function(response) {
                self.loading = false;
                return response;
            });
        }

        function updateProcess() {
            return processDataSrvc.update({
                pk: self.processData.pk
            }, self.processData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", processMessagesConst.update);
                    $state.go('layout.process.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function onProcessStageReorder(row, newPos) {
            return processStageDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }

        function onProcessStageCreate() {
            $uibModal.open({
                templateUrl: 'app/process/views/process-stage-create/process-stage-create.html',
                controller: 'ProcessStageCreateController',
                controllerAs: 'ctrl',
                resolve: {
                    currentProcess: function() {
                        return self.processData;
                    }
                }
            }).result.then(
                function(result) {
                    notificationSrvc.notification("success", processStageMessagesConst.add);
                    getProcessStagesRow(result.pk, function(response) {
                        self.processStagesRows.push(response[0]);
                    });
                    return result;
                }
            );
        }

        function onProcessStageEdit(row) {
            processStageDataSrvc.get({
                pk: row.pk
            }).$promise.then(function(response) {
                $uibModal.open({
                    templateUrl: 'app/process/views/process-stage-update/process-stage-update.html',
                    controller: 'ProcessStageUpdateController',
                    controllerAs: 'ctrl',
                    resolve: {
                        currentProcess: function() {
                            return self.processData;
                        },
                        row: function() {
                            return response;
                        }
                    }
                }).result.then(
                    function(result) {
                        notificationSrvc.notification("success", processStageMessagesConst.update);
                        getProcessStagesRow(result.pk, function(response) {
                            var index = self.processStagesRows.indexOf(row);
                            self.processStagesRows[index] = response[0];
                        });
                        return result;
                    }
                );
            });
        }

        function onProcessStageDelete(row) {
            return processStageSrvc.remove(row.machine_name + ' -> ' + row.machine_action_name, row.pk, function(response) {
                notificationSrvc.notification("success", processStageMessagesConst.delete);
                var index = self.processStagesRows.indexOf(row);
                self.processStagesRows.splice(index, 1);
                return response;
            });
        }
    }
})();
